import {base_url} from '../config';

/**
 * Base URL for hosted widget static files (no trailing slash).
 * Override with REACT_APP_WIDGET_BASE_URL when the widget is not under API origin + /widget.
 */
export function getWidgetAssetBaseUrl() {
  const explicit = process.env.REACT_APP_WIDGET_BASE_URL;
  if (explicit) {
    return explicit.replace(/\/$/, '');
  }
  try {
    if (!base_url) return '';
    return `${new URL(base_url).origin}/widget`;
  } catch {
    return '';
  }
}

export function withWidgetCacheBust(urlPath, version) {
  if (!version) return urlPath;
  const sep = urlPath.includes('?') ? '&' : '?';
  return `${urlPath}${sep}v=${encodeURIComponent(version)}`;
}

/**
 * Entry scripts only; lazy chunks load from the same /widget/js and /widget/css deploy folders.
 *
 * @param {string} chatbotId
 * @param {string} [lang]
 * @param {string} [assetVersion] from fetchWidgetAssetVersion() or REACT_APP_WIDGET_ASSET_VERSION
 */
export function buildWidgetEmbedSnippet(chatbotId, lang = 'en', assetVersion = '') {
  const base = getWidgetAssetBaseUrl() || 'https://admin.hugo.legal/widget';
  const v = assetVersion || process.env.REACT_APP_WIDGET_ASSET_VERSION || '';
  const asset = (suffix) => withWidgetCacheBust(`${base}${suffix}`, v);
  return `<link href="${asset('/css/chat-widget.css')}" rel="stylesheet" />


					  <script>
						var chatbotId = '${chatbotId}';
						var lang = '${lang}';
					  </script>
					  <script src="${asset('/js/runtime.js')}"></script>
					  <script src="${asset('/js/chunk.js')}"></script>
					  <script src="${asset('/js/main.js')}"></script>`;
}

/**
 * Reads widget deploy version for cache-busting embed URLs.
 * Tries API (when version is deployed under server/public/widget), then static widget-asset-version.txt on the widget host.
 */
export async function fetchWidgetAssetVersion() {
  const apiUrl = base_url ? `${String(base_url).replace(/\/$/, '')}/system/widget-asset-version` : '';
  if (apiUrl) {
    try {
      const r = await fetch(apiUrl, {credentials: 'omit'});
      if (r.ok) {
        const data = await r.json();
        if (data && data.v) return String(data.v).trim();
      }
    } catch {
      /* ignore */
    }
  }
  const widgetBase = getWidgetAssetBaseUrl();
  if (widgetBase) {
    try {
      const r = await fetch(`${widgetBase}/widget-asset-version.txt`, {cache: 'no-store'});
      if (r.ok) return (await r.text()).trim();
    } catch {
      /* ignore */
    }
  }
  return '';
}
